import { render, staticRenderFns } from "./InsightDetail.vue?vue&type=template&id=6e0b430f&"
import script from "./InsightDetail.vue?vue&type=script&lang=js&"
export * from "./InsightDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports